import React, { Component } from "react";
import dayjs from "dayjs";
import Icons from "Common/Icons";
import { CONSTANTS } from "utils/constant";
import utils from "utils";
import { connect } from "react-redux";

export class Heading extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let patient_name = this.props?.details?.name;
    let patient_last_name = this.props?.details?.last_name;
    let patient_plan_name = this.props?.details?.display_plan_name;
    let plan_valid_date = this.props?.details?.membership_expiry_date;
    let active_plan = dayjs().isBefore(dayjs(plan_valid_date), "day") || dayjs().isSame(dayjs(plan_valid_date), "day");
    return (
      <>
        {this.props.data.location.pathname == "/logged-in-user/dashboard" && (
          <div className="new-heading">
            <span className="header">
              {CONSTANTS.WELCOME}{" "}
              {utils.FormatName(
                utils.getDisplayName(patient_name, patient_last_name)
              )}
            </span>
            <span className="new-subheading">
              {CONSTANTS.DASHBOARD_MESSAGE}
            </span>
          </div>
        )}
        {(this.props.data.location.pathname ==
          "/logged-in-user/assessment-history" ||
          this.props.data.location.pathname ==
            "/logged-in-user/new-select-assessment" ||
          this.props.data.location.pathname ==
            "/logged-in-user/take-assessment/emotion" ||
          this.props.data.location.pathname ==
            "/logged-in-user/take-assessment/stress" ||
          this.props.data.location.pathname ==
            "/logged-in-user/take-assessment/senior_adult") && (
          <div className="new-heading">
            <span className="header">
              <img className="new-heading-icon" src={Icons.assessment_header} />{" "}
              {CONSTANTS.SELF_ASSESSMENT}
            </span>
            <span className="new-subheading">
              {CONSTANTS.ASSESSMENT_HEADER}
            </span>
          </div>
        )}
        {this.props.data.location.pathname ==
          "/logged-in-user/score-details" && (
          <div className="new-heading">
            <span className="header">
              <img className="new-heading-icon" src={Icons.pie_chart_header} />{" "}
              {CONSTANTS.YOUR_RESULTS}
            </span>
            <span className="new-subheading">
              {this.props.assessment_question_type =="emotion"  ?
               CONSTANTS.ASSESSMENT_RESULT_HEADER:
               this.props.assessment_question_type=="stress"?
               CONSTANTS.ASSESSMENT_STRESS_HEADER: CONSTANTS.ASSESSMENT_GERIATRIC_HEADER
          }
            </span>
          </div>
        )}
        {(this.props.data.location.pathname ==
          "/logged-in-user/consultation-history" ||
          this.props.data.location.pathname ==
            "/logged-in-user/schedule-appointment" ||
          this.props.data.location.pathname ==
            "/logged-in-user/select-doctor") && (
          <div className="new-heading">
            <span className="header">
              <img
                className="new-heading-icon"
                src={Icons.schedule_appointment_header}
              />{" "}
              {CONSTANTS.SCHEDULE_APPOINTMENT}
            </span>
            <span className="new-subheading">
              {CONSTANTS.APPOINTMENT_HEADER}
            </span>
          </div>
        )}
        {(this.props.data.location.pathname ==
          "/logged-in-user/subscription-plan" ||
          this.props.data.location.pathname ==
            "/logged-in-user/coupon-apply") && (
          <div className="new-heading">
            <span className="header">
              <img
                className="new-heading-icon"
                src={Icons.subscription_header}
              />{" "}
              {CONSTANTS.CARE_PLAN}
            </span>
            <span className="new-subheading">
              {CONSTANTS.SUBSCRIPTION_HEADER}
            </span>
          </div>
        )}
        {this.props.data.location.pathname ==
          "/logged-in-user/health-profile" && (
          <div className="new-heading">
            <span className="header">
              <img
                className="new-heading-icon"
                src={Icons.health_info_header}
              />{" "}
              {CONSTANTS.HEALTH_INFORMATION}
            </span>
            <span className="new-subheading">
              {CONSTANTS.HEALTH_INFORMATION_HEADER}
            </span>
          </div>
        )}
        {this.props.data.location.pathname ==
          "/logged-in-user/document-upload" && (
          <div className="new-heading">
            <span className="header">
              <img
                className="new-heading-icon"
                src={Icons.document_upload_header}
              />{" "}
              {CONSTANTS.DOCUMENT_UPLOAD}
            </span>
            <span className="new-subheading">
              {CONSTANTS.DOCUMENT_UPLOAD_HEADER}
            </span>
          </div>
        )}
        {this.props.data.location.pathname == "/logged-in-user/my-order" && (
          <div className="new-heading">
            <span className="header">
              <img className="new-heading-icon" src={Icons.my_orders_header} />{" "}
              {CONSTANTS.MY_ORDERS}
            </span>
            <span className="new-subheading">{CONSTANTS.MY_ORDERS_HEADER}</span>
          </div>
        )}
        {this.props.data.location.pathname == "/logged-in-user/profile-lists" && (
          <div className="new-heading">
            <span className="header">
              <img className="new-heading-icon" src={Icons.switch_account_header} />{" "}
              {CONSTANTS.SWITCH_ACCOUNT}
            </span>
            <span className="new-subheading">{CONSTANTS.CHOOSE_A_PROFILE}</span>
          </div>
        )}
        {(this.props.data.location.pathname ==
          "/logged-in-user/my-account-child" ||
          this.props.data.location.pathname ==
            "/logged-in-user/my-account") && (
          <div className="new-heading">
            <span className="header">
              <img className="new-heading-icon" src={Icons.my_profile_header} />{" "}
              {utils.FormatName(
                utils.getDisplayName(patient_name, patient_last_name)
              )}
            </span>
            {active_plan ? (
              <span className="new-subheading">
                {patient_plan_name}, {CONSTANTS.VALID_UPTO}{" "}
                <span className="date-color">
                  {utils.FormatDate(plan_valid_date, "DATE_14")}
                </span>
              </span>
            ) : (
              <span className="new-subheading">
                {CONSTANTS.MY_PROFILE_HEADING_MESSAGE}
              </span>
            )}
          </div>
        )}
         {this.props.data.location.pathname ==
          "/logged-in-user/vital-form" && (
          <div className="new-heading">
            <span className="header">
              <img
                className="new-heading-icon"
                src={Icons.health_info_header}
              />{" "}
              {/* {CONSTANTS.HEALTH_INFORMATION} */}
              Vital Form
            </span>
            <span className="new-subheading">
              {/* {CONSTANTS.HEALTH_INFORMATION_HEADER} */}
              Vital  Details
            </span>
          </div>
        )}
      </>
    );
  }
}

const MapStateToProps=(state)=>{
  return{
  assessment_question_type: state.assessmentReducer.headingQuestionType
  }
}
export default connect(MapStateToProps) (Heading);
